<template>
  <v-container fluid class="loc_id mt-0 pt-0 pb-0 mb-0">
    <v-layout wrap>
      <v-layout v-if="showLocIdInput" wrap class="mt-6">
        <v-flex
          v-if="
            ($route.path === '/' || $route.path === '/nbn-orders') &&
            !sqResult.correlationId &&
            queryAddress.length > 1
          "
        >
          <p class="red--text mb-0">
            *SQ result is required. Select location ID then click Run NBN SQ.
          </p>
        </v-flex>
        <v-flex
          v-if="hasMatch"
          sm11
          md11
          lg11
          :class="$vuetify.breakpoint.xs ? 'pb-0 mb-0' : ''"
        >
          <ValidationProvider
            v-slot="{ errors }"
            name="Location ID"
            rules="required|alpha_num|length:15|locationId"
          >
            <v-autocomplete
              v-if="queryAddress.length > 1"
              v-model="locId"
              outline
              :items="sortedQueryAddress"
              label="Select Location ID"
              :item-text="locationText"
              item-value="locationId"
              :error-messages="errors"
              :clearable="!isOriginal"
              @change="updateLocationId"
              :readonly="isOriginal"
              @click:clear="clearLocId()"
            ></v-autocomplete>
            <v-text-field
              v-else-if="!isOriginal"
              v-model="locId"
              label="Enter a Location ID"
              outline
              :error-messages="errors"
              clearable
              autocomplete="off"
              maxlength="15"
              @input="updateLocId"
              @change="resetData"
              @update:error="disableSqButton"
            ></v-text-field>
          </ValidationProvider>
        </v-flex>
        <v-flex v-else class="mt-5">
          <h4 class="red--text">No matching addresses found.</h4>
        </v-flex>
        <v-flex
          v-if="showNbnButton"
          sm1
          md1
          lg1
          :class="$vuetify.breakpoint.xs ? 'pt-0 mb-4' : ''"
        >
          <v-btn
            v-if="showNbnButton"
            class="primary"
            :class="$vuetify.breakpoint.xs ? 'mt-0' : 'mt-2'"
            width="100%"
            large
            :disabled="!locId || disableButton"
            @click="runNBNSQ()"
          >
            Run NBN SQ
          </v-btn>
        </v-flex>
      </v-layout>

      <v-flex sm12 md12 lg12>
        <div v-if="showSqResult" style="overflow-x: auto">
          <div v-if="orderType == 'Business Fibre'" class="border-sm pa-2">
            <h4 class="text-right">
              <span>Address:</span>
              <span class="font-italic font-weight-normal">{{ newAddress }}</span>
            </h4>
          </div>

          <div
            v-else
            class="custom-div mt-4"
            :class="borderClass ? 'serviceable' : 'not-serviceable'"
          >
            <v-card flat>
              <v-title class="headline">*NBN SQ</v-title>
              <v-btn class="primary mb-5 mt-4" @click="copyText">
                Copy Result
              </v-btn>
              
              <div ref="result">
                <div>
                  <p
                    class="custom-p text-right font-weight-bold"
                    :class="addClass"
                  >
                    Address:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>
                    {{ newAddress }}
                  </p>
                </div>

                <div>
                  <p
                    class="custom-p text-right font-weight-bold"
                    :class="addClass"
                  >
                    NBN Co Location ID:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>
                    {{ sqNbnResult.address.id }}
                  </p>
                </div>

                <div :class="!isPendingServiceability ? 'mb-6' : ''">
                  <div
                    class="text-right py-0 pr-0 font-weight-bold"
                    :class="addClass"
                    style="display: inline-block"
                  >
                    Current Technology:
                  </div>
                  <div
                    class="pl-0 py-0"
                    style="display: inline-block"
                    :style="
                      $route.path === '/' ? 'width: 59%;' : 'width: 40%;'
                    "
                  >
                  <span v-html="tier1"></span>
                  {{ formattedSQResult.accessTechnology }}
                  </div>
                </div>

                <div :class="!isPendingServiceability ? 'mb-6' : ''">
                  <div
                    class="text-right py-0 pr-0 font-weight-bold"
                    :class="addClass"
                    style="display: inline-block"
                  >
                    Maximum Speed on Current Technology:
                  </div>
                  <div
                    class="pl-0 py-0"
                    style="display: inline-block"
                    :style="
                      $route.path === '/' ? 'width: 59%;' : 'width: 40%;'
                    "
                  >
                    <span v-html="tier1"></span>
                    {{ maxSpeedOnCurrentTechnology }}
                  </div>
                </div>

                <div v-if="sqNbnResult.sq.siteRestriction.supportingTechnology">
                  <p
                    class="custom-p text-right font-weight-bold"
                    :class="addClass"
                  >
                    Alternate Technology Available:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>
                    {{ alternateTechnology }}
                  </p>
                </div>

                <div v-if="sqNbnResult.sq.siteRestriction.supportingTechnology">
                  <p
                    class="custom-p text-right font-weight-bold"
                    :class="addClass"
                  >
                    Maximum Speed on Alternate Technology:
                  </p>
                  <p class="custom-p">
                    <span v-html="tier1"></span>
                    {{ maxSpeedAlternateTechnology }}
                  </p>
                </div>

                <div
                  class="advanced-details-toggle"
                  @click="showAdvancedResult = !showAdvancedResult"
                >
                  View Advanced Details
                  <v-icon small class="ml-1">
                    {{ showAdvancedResult ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                  </v-icon>
                </div>

                <div class="advanced-result" v-if="showAdvancedResult">
                  <div>
                    <div
                      class="text-right py-0 pr-0 mr-3 font-weight-bold"
                      :class="addClass"
                      style="display: inline-block"
                    >
                      Service Class:
                    </div>
                    <div
                      class="pl-0 py-0 font-weight-bold"
                      style="display: inline-block"
                      :style="
                        $route.path === '/' ? 'width: 59%;' : 'width: 40%;'
                      "
                    >
                      <span v-html="tier1"></span>
                      {{ setValue(formattedSQResult.serviceabilityClass) }}
                    </div>
                    <span v-html="tier1"></span>
                  </div>

                  <div class="mb-6" v-show="isPendingServiceability">
                    <div
                      class="text-right py-0 pr-0 mr-3 font-weight-bold"
                      :class="addClass"
                      style="display: inline-block"
                    >
                      Planned Serviceability Date:
                    </div>
                    <div
                      class="pl-0 py-0 font-weight-bold"
                      style="display: inline-block"
                      :style="
                        $route.path === '/' ? 'width: 59%;' : 'width: 40%;'
                      "
                    >
                      <span v-html="tier1"></span>
                      {{ formattedSQResult.serviceabilityDate }}
                    </div>
                  </div>

                  <div>
                    <p
                      class="custom-p text-right font-weight-bold"
                      :class="addClass"
                    >
                      CSA Id:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ formattedSQResult.csaid }}
                    </p>
                  </div>

                  <div>
                    <p
                      class="custom-p text-right font-weight-bold"
                      :class="addClass"
                    >
                      Address Latitude &amp; Longitude:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ formattedSQResult.latitude }},
                      {{ formattedSQResult.longitude }}
                    </p>
                  </div>

                  <div>
                    <p
                      class="custom-p text-right font-weight-bold"
                      :class="addClass"
                    >
                      Region:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ formattedSQResult.region }}
                    </p>
                  </div>

                  <div v-for="(item, index) in nfas" :key="item.name + index">
                    <p
                      class="custom-p text-right font-weight-bold"
                      :class="addClass"
                    >
                      {{ `${item.name}:` }}
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.value }}
                    </p>
                  </div>

                  <div
                    v-if="
                      sqNbnResult.sq.siteRestriction.supportingResource
                        .length == 0 &&
                      (isFttc || isFttn || isFttb)
                    "
                    class="mt-4 pt-4 row-border"
                  >
                    <p
                      class="custom-p text-right font-weight-bold"
                      :class="addClass"
                    >
                      Copper pairs at this location:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      No known copper pairs currently listed at this location
                    </p>
                  </div>

                  <div
                    v-if="sqNbnResult.sq.siteRestriction.supportingResource"
                    v-for="(item, index) in sqNbnResult.sq.siteRestriction
                      .supportingResource"
                    :key="index"
                    class="mt-4 pt-4 row-border"
                  >
                    <div v-if="item.id != null">
                      <p
                        class="custom-p text-right font-weight-bold"
                        :class="addClass"
                      >
                        {{ hasNtd ? 'NTD ID:' : 'Copper Pair ID:' }}
                      </p>
                      <p class="custom-p">
                        <span v-html="tier1"></span>
                        {{ item.id }}
                      </p>
                    </div>

                    <div v-if="item.POTSInterconnectMatch != null">
                      <p
                        class="custom-p text-right font-weight-bold"
                        :class="addClass"
                      >
                        POTSInterconnectMatch
                      </p>
                      <p class="custom-p">
                        <span v-html="tier1"></span>
                        {{ item.POTSInterconnectMatch }}
                      </p>
                    </div>
                    
                    <div
                      v-if="showSection(item, 'cpiDetails')"
                      style="margin: 10px 0"
                    >
                      <div
                        v-for="(item, index) in item.cpiDetails"
                        :key="item.name + index"
                      >
                        <p
                          class="custom-p text-right font-weight-bold"
                          :class="addClass"
                        >
                          {{ `${item.name}:` }}
                        </p>
                        <p class="custom-p">
                          <span v-html="tier1"></span>
                          {{ item.value }}
                        </p>
                      </div>
                    </div>
                    
                    <div
                      v-if="showSection(item, 'uniPortD')"
                      style="margin: 10px 0"
                    >
                      <div
                        class="text-right py-0 pr-0 mr-3 font-weight-bold"
                        :class="addClass"
                      >
                        Data, UNI-D:
                      </div>
                      <div class="pl-0 py-0" style="display: inline-block">
                        <div
                          v-for="(subItem, index) in item.uniPortD"
                          :key="index"
                        >
                          <span v-html="tier1"></span>
                          <p
                            style="width: 160px; display: inline-block"
                            class="mb-0"
                          >
                            {{ getPortNumber(subItem) }}
                          </p>
                          <span v-html="tier2"></span>
                          {{ subItem.status }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="showSection(item, 'uniPortV')"
                      style="margin: 10px 0"
                    >
                      <div
                        class="text-right py-0 pr-0 mr-3 font-weight-bold"
                        :class="addClass"
                      >
                        Voice, UNI-V:
                      </div>
                      <div class="pl-0 py-0" style="display: inline-block">
                        <div
                          v-for="(subItem, index) in item.uniPortV"
                          :key="index"
                        >
                          <span v-html="tier1"></span>
                          <p
                            style="width: 160px; display: inline-block"
                            class="mb-0"
                          >
                            {{ getPortNumber(subItem) }}
                          </p>
                          <span v-html="tier2"></span>
                          {{ subItem.status }}
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="item.type == 'NTD' && item.ntdDetails.length > 0"
                      style="margin: 10px 0"
                    >
                      <div
                        class="text-right py-0 pr-0 mr-3 font-weight-bold"
                        :class="addClass"
                      >
                        NTD Details:
                      </div>
                      <div class="pl-0 py-0" style="display: inline-block">
                        <div
                          v-for="(subItem, index) in item.ntdDetails"
                          :key="index"
                        >
                          <span v-html="tier1"></span>
                          <p
                            style="width: 160px; display: inline-block"
                            class="mb-0"
                          >
                            {{ subItem.name }}
                          </p>
                          <span v-html="tier2"></span>
                          {{ subItem.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="sqNbnResult.sq.siteRestriction.supportingProduct"
                    v-for="(item, index) in sqNbnResult.sq.siteRestriction
                      .supportingProduct"
                    :key="index"
                    class="mt-4 pt-4 row-border"
                  >
                    <p
                      class="custom-p text-right font-weight-bold"
                      :class="addClass"
                    >
                      Product Id:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.id }}
                    </p>
                    <p
                      class="custom-p text-right font-weight-bold"
                      :class="addClass"
                    >
                      Resource Ref:
                    </p>
                    <p class="custom-p">
                      <span v-html="tier1"></span>
                      {{ item.resourceRef }}
                    </p>
                  </div>
                </div>
                <!-- end -->
              </div>
            </v-card>
          </div>
        </div>
        
        <div v-if="showSqResult5G" style="overflow-x: auto">
          <div class="custom-div mt-4" :class="borderClass ? 'serviceable' : 'not-serviceable'">
            <v-title class="headline">*5G SQ</v-title>
            <v-btn class="primary mb-5 mt-4" @click="copyText">
              Copy Result
            </v-btn>
            <UtilityServiceQualification5gResult 
              :speed="speed"
            />
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapSQActions } = createNamespacedHelpers(`orders/sq`);
const { mapActions: mapSQAddressActions } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapGetters: mapSQAddressGetters } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapGetters: mapSQGetters } = createNamespacedHelpers(`orders/sq`);
const { mapGetters: mapFeatureFlagGetters } = createNamespacedHelpers(`orders/featureFlag`);
import UtilityServiceQualification5gResult from './utility-service-qualification-5g-result';
import { resolveBandwidthProfileKey, getMaxBandwidthProfileText } from '../../constants/nbn-sq-constants';
export default {
  name: 'QualificationResult5g',
  components: {
    UtilityServiceQualification5gResult,
  },
  props: {
    showLocIdInput: { type: Boolean },
    showButtons: { type: Boolean },
    queryAddress: { type: Array },
    hideOtherButtons: { type: Boolean },
    selected: { type: String },
    hasMatch: { type: Boolean },
    speed: { type: String },
  },
  data: () => ({
    disableButton: false,
    result: {},
    locId: '',
    newResult: null,
    tier1: '&nbsp;',
    tier2: '&nbsp;&nbsp;&nbsp;',
    tier3: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
    tier4: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
    sorting: -1,
    showSqResult: false,
    showSqResult5G: false,
    serviceClass: [
      {
        class: '0',
        description:
          "Planned to be serviced by Fibre in the future (boundary status isn't 'In Service' yet)",
      },
      {
        class: '1',
        description: 'Serviceable by Fibre, no drop or NTD in place',
      },
      {
        class: '2',
        description: 'Serviceable by Fibre, drop in place, no NTD in place',
      },
      {
        class: '3',
        description: 'Serviceable by Fibre, drop and NTD in place',
      },
      {
        class: '4',
        description: 'Planned to be serviced by Wireless',
      },
      {
        class: '5',
        description: 'Serviceable by Wireless, CPE not installed',
      },
      {
        class: '6',
        description: 'Serviceable by Wireless, CPE installed',
      },
      {
        class: '7',
        description: 'Planned to be serviced by Satellite',
      },
      {
        class: '8',
        description: 'Serviceable by Satellite, Satellite - NTD not installed',
      },
      {
        class: '9',
        description: 'Serviceable by Satellite, Satellite - NTD installed',
      },
      {
        class: '10',
        description: 'Planned to be serviceable by Copper',
      },
      {
        class: '11',
        description: 'Serviceable by copper, active node present',
      },
      {
        class: '12',
        description: 'Serviceable by copper, jumpering is required',
      },
      {
        class: '13',
        description: 'Serviceable by copper, infrastructure in place',
      },
      {
        class: '20',
        description:
          'Planned to be serviced by HFC, outside plant does not exist',
      },
      {
        class: '21',
        description:
          'Serviceable by HFC, the location has a street TAP but requires a lead-in, PCD, internal tie cable, and wall-plate/socket',
      },
      {
        class: '22',
        description:
          'Serviceable by HFC, the location has a street TAP, lead-in & PCD in place, but no internal tie-cables with wall plates/sockets',
      },
      {
        class: '23',
        description:
          'Serviceable by HFC, the location has a wall-plate/socket but no HFC NTD',
      },
      {
        class: '24',
        description:
          "Serviceable by HFC, Location has a wall-plate/socket & HFC NTD and is 'Ready to Connect'",
      },
      {
        class: '30',
        description: 'Planned to be serviceable by FTTC',
      },
      {
        class: '31',
        description: 'Serviceable by FTTC, no line available (RPU required)',
      },
      {
        class: '32',
        description: 'Serviceable by FTTC, cut-in required (RPU required)',
      },
      {
        class: '33',
        description: 'Serviceable by FTTC, cut-in complete (RPU required)',
      },
      {
        class: '34',
        description:
          'Serviceable by FTTC, infrastructure in place (Check RPU status)',
      },
    ],
    showAdvancedResult: false,
  }),
  methods: {
    ...mapSQActions([
      'setLocationID',
      'reset5gSq',
      'setOrderType',
      'setSqResult',
      'resetFormattedSQResult',
      'setAddressQueryResult',
      'resetHasNtd',
      'setFormattedSQResult',
      'serviceQualificationNbn',
      'setFormattedNbnSQResult',
      'setProductType',
      'setNtdId',
      'setCpiId',
    ]),
    clearLocId() {
      let vm = this;
      vm.setLocationID("");
      vm.setSqResult({});
      vm.resetFormattedSQResult();
    },
    locationText(val) {
      return `${val.formattedAddress} (${val.locationId})`;
    },
    createOrder() {
      let vm = this;

      if (vm.orderType === '5g') {
        if (vm.sq5gResult.location) {
          let payload = {
            msisdn: '',
            sectorID: '',
            techType: '5G',
            uploadSpeed: '10',
            downloadSpeed: '50',
          };

          vm.sq5gResult.location.forEach((x) => {
            x.mobileQualification.serviceSpecCharacteristics.forEach((y) => {
              if (y.name === 'SectorID') payload.sectorID = y.value;
            });
          });

          vm.$emit('createOrder', {
            withData: true,
            payload: payload,
          });
        }
      } else {
        let streetNrFirst = '',
          streetNrLast = '',
          streetName = '',
          streetType = '',
          suburb = '',
          postcode = '',
          stateOrProvince = '',
          longitude = '',
          latitude = '',
          formattedAddress = '',
          lotNumber = '';

        vm.result.address.additionalParameters.forEach((x) => {
          switch (x.name) {
            case 'streetNrFirst':
              streetNrFirst = x.value;
              break;
            case 'streetNrLast':
              streetNrLast = x.value;
              break;
            case 'streetName':
              streetName = x.value;
              break;
            case 'streetType':
              streetType = x.value;
              break;
            case 'suburb':
              suburb = x.value;
              break;
            case 'postcode':
              postcode = x.value;
              break;
            case 'stateOrProvince':
              stateOrProvince = x.value;
              break;
            case 'longitude':
              longitude = x.value;
              break;
            case 'latitude':
              latitude = x.value;
              break;
            case 'formattedAddress':
              formattedAddress = x.value;
              break;
            case 'lotNumber':
              lotNumber = x.value;
              break;
          }
        });

        let address = {
          streetNrFirst: streetNrFirst,
          streetNrLast: streetNrLast,
          streetName: streetName,
          streetType: streetType,
          suburb: suburb,
          postcode: postcode,
          stateOrProvince: stateOrProvince,
          longitude: longitude,
          latitude: latitude,
          locationId: vm.locationId,
          formattedAddress: formattedAddress,
          lotNumber: lotNumber,
        };

        vm.$emit('createOrder', {
          withData: true,
          address: address,
          sqResult: vm.result,
          locationId: vm.locationID,
        });
      }
    },
    updateLocationId() {
      let vm = this;
      vm.setLocationID(vm.locId);
      vm.resetData();
    },
    resetData() {
      let vm = this;
      vm.hideResult();
      vm.setLocationID(vm.locId);
    },
    getPortNumber(data) {
      return `Port ${data.id.substring(data.id.length - 1, data.id.length)}`;
    },
    hideResult() {
      let vm = this;
      vm.result = {};
      vm.reset5gSq();
    },

    createEmail() {
      let vm = this;
      vm.createTemplatedEmail().then(() => {
        //
      });
    },
    runNBNSQ() {
      let vm = this;
      let payload = {};
      vm.resetData();
      vm.resetHasNtd();
      if(vm.orderType == 'nbn') vm.setOrderType('nbn');

      payload = {
        addressCheckMethodType: 'NBN_LOCATION_ID',
        addressValue: {
          LocationId: vm.locId,
        },
      };

      if (vm.cad !== '') {
        payload.cad = vm.cad;
      }

      if (vm.potsInterconnect !== '') {
        payload.pots = vm.potsInterconnect;
      }

      this.$emit('toggleLoading', true);
      vm.serviceQualificationNbn(payload).then((data) => {
        this.$emit('toggleLoading', false);
        if(data.success){
          vm.showSqResult = true;
          vm.setFormattedNbnSQResult(data.data);
          // vm.setProductType(data.data.sq.siteRestriction.supportingTechnology.primaryAccessTechnology);
          // vm.setNtdId(data.data);
          // vm.setCpiId(data.data);
          if(vm.orderType == 'Business Fibre') {
            vm.address = vm.newAddress
          }
          vm.$emit('showResultSection', data.data);
          vm.result = data.data;
        } else {
          vm.setMessage({
            message: data.message,
            httpStatus: 500,
          });
        }
      });
    },
    cancel() {
      let vm = this;
      vm.result = {};
      vm.setLocationID('');
      vm.setAddressQueryResult({});
      vm.$emit('cancel');
    },
    copyText() {
      let vm = this;
      vm.selectText(vm.$refs.result);
      document.execCommand('copy');
    },
    selectText(element) {
      var range;
      if (document.selection) {
        document.create;
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        range = document.createRange();
        range.selectNode(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    },
    setValue(item) {
      let vm = this;
      return `${item} - ${
        vm.formattedSQResult.serviceability
      }. ${vm.setDescription(item)}.`;
    },
    setDescription(item) {
      let vm = this;
      let description = '';
      vm.serviceClass.forEach((x) => {
        if (x.class === item) description = x.description;
      });

      return description;
    },
    updateLocId() {
      let vm = this;
      if (!vm.locId) {
        vm.showSqResult = false;
      }
      vm.setLocationID(vm.locId);
    },
    showSection(data, type) {
      if (data[type] !== undefined) return true;
      else return false;
    },
    showDetails(data, types) {
      let vm = this;
      let show = false;
      types.forEach((x) => {
        if (vm.showSection(data, x)) show = true;
      });
      return show;
    },
    disableSqButton(disable) {
      let vm = this;
      if (disable) vm.disableButton = true;
      else vm.disableButton = false;
    },
    getAvailableSpeedTierValues() {
      const siteRestriction = this.sqNbnResult?.sq?.siteRestriction;
      const features = siteRestriction?.supportingProductFeatures;
      const productFeatures = Array.isArray(features) ? features[0] : features;

      const fromProduct = productFeatures?.speedTierAvailability;
      if (fromProduct?.length) {
        return fromProduct;
      }

      const ntd = siteRestriction?.supportingResource?.find((r) => r.type === 'NTD');
      const fromNtd =
        ntd?.speedTiersSupported
          ?.filter((t) => t.supported)
          .map((t) => t.featureType) ?? [];

      return fromNtd;
    },

    formatMaxSpeed() {
      const siteRestriction = this.sqNbnResult?.sq?.siteRestriction;
      if (!siteRestriction) return 'Not Available';

      const technology =
        siteRestriction.supportingTechnology?.primaryAccessTechnology;

      const features = siteRestriction.supportingProductFeatures;
      const productFeatures = Array.isArray(features) ? features[0] : features;
      const productType = productFeatures?.type;

      const profileKey = resolveBandwidthProfileKey(technology, productType);
      if (!profileKey) return 'Not Available';

      const availableTiers = this.getAvailableSpeedTierValues();
      return getMaxBandwidthProfileText(profileKey, availableTiers);
    },
  },
  computed: {
    ...mapSQGetters([
      'orderType',
      'sq5gResult',
      'sqResult',
      'formattedSQResult',
      'nfas',
      'locationID',
      'hasNtd',
      'hasSectorID',
      'sqNbnResult',
      'isPendingServiceability',
      'hasActiveServices',
      'isOriginal',
    ]),
    ...mapSQAddressGetters(['fullAddress']),
    ...mapFeatureFlagGetters(['allFlags']),
    activeResource() {
      const resources =
        this.sqNbnResult?.sq?.siteRestriction?.supportingResource ?? [];
      if (this.hasNtd) {
        return resources.find((r) => r.type === 'NTD') ?? null;
      }
      const copper = resources.filter((r) => r.type === 'CopperLineResource');
      if (!copper.length) return null;
      return (
        copper.find((r) => r.NBNServiceStatus === 'Line In Use') ??
        copper[0]
      );
    },
    maxSpeedOnCurrentTechnology() {
      return this.formatMaxSpeed();
    },
    alternateTechnology() {
      const value =
        this.sqNbnResult?.sq?.siteRestriction?.supportingTechnology
          ?.alternativeTechnology;
      if (value == null || String(value).trim() === '') {
        return 'Not Available';
      }
      if (String(value).toLowerCase().includes('fibre on-demand')) {
        return 'Fibre on Demand';
      }
      return value;
    },
    maxSpeedAlternateTechnology() {
      const value =
        this.sqNbnResult?.sq?.siteRestriction?.supportingTechnology
          ?.alternativeTechnology;

      if (value && String(value).toLowerCase().includes('available for higher speed')) {
        return 'Higher speeds available, subject to qualification';
      }

      return 'Not available at present';
    },
    disableCreateButton() {
      let vm = this;
      if (vm.orderType === 'nbn') return vm.isServiceable;
      else return !vm.hasSectorID;
    },
    isServiceable() {
      let vm = this;
      if (vm.result.serviceability !== undefined) {
        if (vm.result.serviceability.includes('Serviceable')) return true;
        else return false;
      } else {
        if (vm.sq5gResult !== null) return true;
        else return false;
      }
    },
    sortedQueryAddress() {
      return this.queryAddress
        .slice(0)
        .sort((a, b) =>
          parseInt(a.lotNumber) < parseInt(b.lotNumber) ||
          parseInt(a.subUnitNr) < parseInt(b.subUnitNr) ||
          parseInt(a.streetNrFirst) < parseInt(b.streetNrFirst) ||
          parseInt(a.streetName) < parseInt(b.streetName)
            ? this.sorting
            : -this.sorting
        );
    },
    newAddress() {
      let vm = this;
      if (vm.sqNbnResult.address) {
        return vm.sqNbnResult.address.formattedAddress;
      } else return '';
    },
    firstColumn() {
      let vm = this;
      if (vm.$route.path === '/') return '5';
      else return '4';
    },
    secondColumn() {
      let vm = this;
      if (vm.$route.path === '/') return '7';
      else return '8';
    },
    addClass() {
      let vm = this;
      if (vm.$route.path === '/') return 'first-order';
      else return 'first-sq';
    },
    disableOnLookup() {
      let vm = this;
      return vm.selected === 'Location ID' || vm.selected === 'Geocode';
    },
    showNbnButton() {
      let vm = this;

      if (vm.$route.path === '/') {
        return vm.orderType === 'nbn' || vm.orderType === 'Business Fibre';
      } else return true;
    },
    show5GButton() {
      let vm = this;

      if (vm.$route.path === '/') {
        return vm.orderType === '5g';
      } else return true;
    },
    buttonColSize() {
      let vm = this;
      if (vm.$route.path === '/') return '3';
      else return '2';
    },
    fieldColSize() {
      let vm = this;
      if (vm.$route.path === '/') return '9';
      else return '10';
    },
    borderClass() {
      let vm = this;
      if (vm.orderType === 'nbn') {
        vm.$emit('serviceability', vm.isServiceable);
        return vm.isServiceable;
      }
      if (vm.orderType.toLowerCase() === '5g') {
        vm.$emit('serviceability', vm.hasSectorID);
        return vm.hasSectorID;
      }
    },
    isFttc() {
      let vm = this;
      return vm.sqNbnResult.sq
        ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .primaryAccessTechnology === 'Fibre To The Curb'
        : false;
    },
    isFttn() {
      let vm = this;
      return vm.sqNbnResult.sq
        ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .primaryAccessTechnology === 'Fibre To The Node'
        : false;
    },
    isFttb() {
      let vm = this;
      return vm.sqNbnResult.sq
        ? vm.sqNbnResult.sq.siteRestriction.supportingTechnology
            .primaryAccessTechnology === 'Fibre To The Building'
        : false;
    },
  },
  watch: {
    locationID: function () {
      let vm = this;
      vm.locId = vm.locationID;
    },
    locId(val) {
      let vm = this;
      if (!val) {
        vm.showSqResult = false;
      }
    },
    orderType() {
      let vm = this;
      vm.showSqResult = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-div {
  border: 2px solid #9e9e9e;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 15px;
  font-size: 15px !important;
}

.serviceable {
  border-color: #2cd375 !important;
}

.not-serviceable {
  border-color: #ee3923 !important;
}

.row-border {
  border-top: 1px solid #9e9e9e;
}

.custom-p {
  display: inline-block;
  margin-bottom: 2px;
}

.first-sq {
  width: 513px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
}

.first-order {
  width: 445px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
  width: 37%;
}

.loc_id{
  width: 52%;
  margin: 30px 0 0 0 !important;
}

.advanced-details-toggle {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin: 30px 0 15px;
  font-weight: 500;
  user-select: none;
  &:hover {
    opacity: 0.8;
  }
}

@media screen and (max-width: 900px) {
  .loc_id{
    width: 100%;
    position: static;
  }
}

@media screen and (max-width: 1100px) {
  .custom-div {
    width: 1100px;
  }
}
</style>